/**
 * Parses a prompt template string and extracts [Placeholder] tokens.
 * Returns an array of segments: static text and input placeholders.
 * Duplicate labels within the same prompt share the same key.
 */
export function parsePromptTemplate(template) {
    const regex = /\[([^\]]+)\]/g;
    const segments = [];
    let lastIndex = 0;
    let match = regex.exec(template);
    while (match !== null) {
        if (match.index > lastIndex) {
            segments.push({ type: 'text', value: template.slice(lastIndex, match.index) });
        }
        const label = match[1];
        segments.push({ type: 'input', label, key: label });
        lastIndex = regex.lastIndex;
        match = regex.exec(template);
    }
    if (lastIndex < template.length) {
        segments.push({ type: 'text', value: template.slice(lastIndex) });
    }
    return segments;
}
/**
 * Returns the unique input keys from a parsed template.
 */
export function getUniqueInputKeys(segments) {
    const inputKeys = segments.filter((s) => s.type === 'input').map((s) => s.key);
    return Array.from(new Set(inputKeys));
}
/**
 * Checks whether a prompt template has any placeholders.
 */
export function hasPlaceholders(template) {
    return /\[[^\]]+\]/.test(template);
}
/**
 * Assembles a prompt by replacing [Placeholder] tokens with provided values.
 */
export function assemblePrompt(template, values) {
    return template.replace(/\[([^\]]+)\]/g, (_, label) => values[label] || `[${label}]`);
}
